import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionRoomPlanConnection } from "./plan-connection";
import { QuestionRoomSaleTypeForPlan } from "./sale-type-for-plan";

import type { StandardRoomCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	connection: StandardRoomCategoriesAndManagerStore["connection"];
};

export const QuestionRoomConnection = ({ connection }: Props) => {
	return (
		<>
			<FeatureIslandMainWithCategoryWrapper islandTitle="プラン紐付け" categoryStore={connection}>
				<QuestionRoomPlanConnection />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="プラン限定販売" categoryStore={connection}>
				<QuestionRoomSaleTypeForPlan />
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionRoomConnection.displayName = "QuestionRoomConnection";
